import { createFileRoute, redirect } from '@tanstack/react-router'

import { readClubSession } from '@/lib/auth/session-store'
import { LoginPage } from '@/features/auth/LoginPage'

export const Route = createFileRoute('/login')({
  beforeLoad: () => {
    if (readClubSession()) throw redirect({ to: '/dashboard' })
  },
  component: LoginPage,
})
